import { create } from "zustand";

export interface ChainHighlightHandler {
  highlightedShuntingUnitId?: string;
  toggleHighlightedShuntingUnit: (shuntingUnitId: string) => void;
  deselectShuntingUnit: () => void;
}

export const useChainHighlightHandler = create<ChainHighlightHandler>((set) => ({
  toggleHighlightedShuntingUnit: (shuntingUnitId) =>
    set(({ highlightedShuntingUnitId }) => {
      if (highlightedShuntingUnitId !== undefined && shuntingUnitId === highlightedShuntingUnitId) {
        return { highlightedShuntingUnitId: undefined };
      } else {
        return { highlightedShuntingUnitId: shuntingUnitId };
      }
    }),
  deselectShuntingUnit: () => set(() => ({ highlightedShuntingUnitId: undefined })),
}));
